/**
 * Google Analytics 4 Utilities
 * Measurement ID (G-QNKZC1VTLJ) is configured in index.html; these
 * helpers call the global gtag() that script installs.
 */

/**
 * Track a page view
 * @param {string} path - The page path
 * @param {string} title - The page title
 */
export function trackPageView(path, title) {
  if (typeof window.gtag !== 'function') return

  window.gtag('event', 'page_view', {
    page_path: path,
    page_title: title,
    page_location: window.location.href,
  })
}

/**
 * Track a click event
 * @param {string} category - Event category (e.g., 'CTA', 'Navigation', 'Link')
 * @param {string} label - Event label (e.g., 'Start Free Button', 'Pricing Link')
 * @param {string} [value] - Optional value
 */
export function trackClick(category, label, value) {
  if (typeof window.gtag !== 'function') return

  window.gtag('event', 'click', {
    event_category: category,
    event_label: label,
    value: value,
  })
}

/**
 * Track CTA button clicks
 * @param {string} ctaName - Name of the CTA
 * @param {string} location - Where the CTA is located (e.g., 'hero', 'footer')
 */
export function trackCTA(ctaName, location) {
  if (typeof window.gtag !== 'function') return

  window.gtag('event', 'cta_click', {
    cta_name: ctaName,
    cta_location: location,
  })
}

/**
 * Track outbound link clicks
 * @param {string} url - The outbound URL
 * @param {string} label - Description of the link
 */
export function trackOutboundLink(url, label) {
  if (typeof window.gtag !== 'function') return

  window.gtag('event', 'click', {
    event_category: 'outbound',
    event_label: label,
    transport_type: 'beacon',
    event_callback: () => {
      document.location = url
    },
  })
}

/**
 * Track form submissions
 * @param {string} formName - Name of the form
 * @param {boolean} success - Whether submission was successful
 */
export function trackFormSubmission(formName, success) {
  if (typeof window.gtag !== 'function') return

  window.gtag('event', success ? 'form_submit_success' : 'form_submit_error', {
    form_name: formName,
  })
}

/**
 * Track navigation clicks
 * @param {string} linkName - Name of the navigation link
 * @param {string} destination - Where the link goes
 */
export function trackNavigation(linkName, destination) {
  if (typeof window.gtag !== 'function') return

  window.gtag('event', 'navigation_click', {
    link_name: linkName,
    destination: destination,
  })
}

export default {
  trackPageView,
  trackClick,
  trackCTA,
  trackOutboundLink,
  trackFormSubmission,
  trackNavigation,
}
